import React, { useState } from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="hero-section">
      {!imageError && (
        <img 
          src="/hero-image.jpg" 
          alt="Professionnel Obtengo" 
          className="hero-image"
          onError={handleImageError}
        />
      )}
      <div className="image-overlay"></div>
      <div className="hero-content">
        <img 
          src="/assets/logo-obtengo.png" 
          alt="Obtengo - Des solutions claires, guidées par vos besoins" 
          className="logo-image"
        />
      </div>
    </div>
  );
};

export default HeroSection;

